import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class TenantService extends BaseService{
	constructor() {
		super('/Tenant');
	}

	public updateTenantLock(id:number, isLock: boolean) {
		return super.updateBase(this._resourceName + '/lock/' + id +'/'+  isLock,null);
	}

	public getAllByFilter(filter: TenantFilter) {
		return super.getAllByFilterBase(filter);
	}

	public resendRegistration(id: number, data: any) {
		return super.updateBase(this._resourceName + "/ResendRegistration/" + id, data);
	}

	public confirmRegistrationTenant(id: number, data: any) {
		return super.updateBase(this._resourceName + "/ConfirmRegistrationTenant/" + id, data);
	}

}

export class TenantFilter extends BaseFilter {
	constructor(isDeleted?: boolean | null, isActive?: boolean | null) {
		super();
		this._isDeleted = isDeleted;
		this._isActive = isActive;
	}

	private _isDeleted?: boolean | null;
	private _isActive?: boolean | null;

	public getAllParams(): {} {

		let data = Object.assign({},
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {}),
			(this._isActive != null ? { IsActive: this._isActive } : {})
		);

		return data;
	};
}